import gql from 'graphql-tag';

const MUTATION_UPDATE_USER = gql`
  mutation udpateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      isSuccess
      message
      user {
        id
        email
      }
    }
  }
`;

export default MUTATION_UPDATE_USER;
